import QuestionCard from './QuestionCard';
export { QuestionCard };
export default QuestionCard;
